export * from "https://cdn.kernvalley.us/js/std-js/htmlpurify.js";
console.warn('`purify.js` has been moved to `htmlpurify.js`');